import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Text from '@components/Text'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const toP = (text) => `<p>${text.split(/[\r\n\t]+/gm).join('</p><p>')}</p>`

const ExpandLink = styled.button`
  &&& {
    border: 0;
    margin: 0;
    padding: 0;
    letter-spacing: ${tokens.letterSpacing[0].value};
    font-weight: ${tokens.fontWeights.ivarDisplay3.value};
    background: transparent;
  }
`

const ExpandText = ({ className, sliceAt, children, splitToP, readMoreLabel, ...props }) => {
  const longText = children
  const isLong = children.length > sliceAt
  const [expanded, setExpanded] = useState(!isLong)
  const smallText = isLong ? `${children.slice(0, sliceAt)}...` : null
  const visibleText = expanded ? longText : smallText

  return (
    <div className={className}>
      <Text isHtml {...props}>
        {splitToP ? toP(visibleText) : visibleText}
      </Text>
      {!expanded ? (
        <ExpandLink variant='secondary' onClick={() => setExpanded(true)}>
          <Text forwardedAs='span' isSmall>
            {readMoreLabel || 'Read More'}
          </Text>
        </ExpandLink>
      ) : null}
    </div>
  )
}

ExpandText.propTypes = {
  className: PropTypes.string,
  sliceAt: PropTypes.number.isRequired,
  children: PropTypes.string.isRequired,
  splitToP: PropTypes.bool,
  readMoreLabel: PropTypes.string,
  ...Text.propTypes
}

export default ExpandText
